<template>

    <div v-if="session.user_data != null">

      <v-card flat v-if="editable && !hide_settings">

        <v-card-title class="pa-0">

          <v-spacer></v-spacer>
          <v-btn icon @click="sheet = !sheet">
            <v-icon>mdi-cogs</v-icon>
          </v-btn>

        </v-card-title>


      </v-card>


      <slot name="before-widgets"></slot>

      <v-bottom-sheet v-model="sheet" v-if="editable == true">
        <v-sheet class="text-center">
          <v-btn
              class="mt-6"
              text
              color="red"
              @click="sheet = !sheet"
          >close
          </v-btn>


          <v-container>
            <v-layout row>

              <v-flex xs6 md3 v-for="(widget, index) in widgets" :key="index">

                <v-checkbox :label="$t(widget.title)" v-model="widget.active" @change="saveWidgets()"></v-checkbox>

              </v-flex>

            </v-layout>

          </v-container>

        </v-sheet>
      </v-bottom-sheet>

      <v-row>

        <v-col cols="12" md="8">

          <draggable v-if="!is_loading" :list="primary_widgets" ghost-class="ghost" group="widgets" @end="saveWidgets()"
                     handle=".handle">


            <v-card outlined class="mb-3" v-for="(widget, index) in primary_widgets" v-if="widget.active" :key="index"
                    >

              <v-toolbar flat dense>

                <v-toolbar-title>
                  {{ $t(widget.title) }}
                </v-toolbar-title>


                <v-spacer></v-spacer>
                <v-icon class="handle" v-if="draggable">mdi-drag-vertical</v-icon>

              </v-toolbar>


              <v-lazy
                      :options="{threshold: 0}"
                      transition="fade-transition" min-height="50">

                <v-component :is="widget.component"></v-component>

              </v-lazy>

            </v-card>


          </draggable>

        </v-col>
        <v-col cols="12" md="4">


          <draggable v-if="!is_loading" :list="secondary_widgets" ghost-class="ghost" group="widgets"
                     @end="saveWidgets()" handle=".handle">

            <v-card outlined class="mb-3" v-for="(widget, index) in secondary_widgets" v-if="widget.active"
                    :key="index">

              <v-toolbar flat dense>

                <v-toolbar-title>
                  {{ $t(widget.title) }}
                </v-toolbar-title>


                <v-spacer></v-spacer>
                <v-icon class="handle" v-if="draggable">mdi-drag-vertical</v-icon>

              </v-toolbar>

              <v-lazy :options="{threshold: 0}"
                      transition="fade-transition"
              >

                <v-component :is="widget.component"></v-component>

              </v-lazy>

            </v-card>

          </draggable>

        </v-col>

      </v-row>



    </div>

</template>


<script>
  import draggable from "vuedraggable";
  import { sessionStore } from '@/store/pinia/sessionStore'


  export default {
    setup() {

      const session = sessionStore();

      return {
        // you can return the whole store instance to use it in the template
        session,
      }

    },
    components: {draggable},
    props: {
      panelType: null,
      widgets: {},
      draggable: {
        type: Boolean,
        default: false
          },
          editable: {
            type: Boolean,
            default: false
          },
          hide_settings: {
            type: Boolean,
            default: false
          }
        },
    data() {
      return {
        is_loading: true,
        sheet: false,
        primary_widgets: [],
        secondary_widgets: [],
        default_widgets: [],
        initializing: true
      }
    },

    computed: {


    },

    mounted() {

      this.loadWidgets();

    },

    methods: {


          toggleSettings(){

            this.sheet = !this.sheet;

          },

            saveWidgets() {


              let self = this;


              if (self.editable == false) {
                return;
              }


              let primaryWidgets = JSON.parse(JSON.stringify(self.primary_widgets));
              let secondaryWidgets = JSON.parse(JSON.stringify(self.secondary_widgets));


              primaryWidgets.forEach(function (item, index) {
                item.position = index;
              });
              secondaryWidgets.forEach(function (item, index) {
                item.position = index;
              });


              localStorage.setItem('widget_panel::' + self.panelType + '::primary', JSON.stringify(primaryWidgets));
              localStorage.setItem('widget_panel::' + self.panelType + '::secondary', JSON.stringify(secondaryWidgets));


              console.log('Save Widgets');


            },

            loadWidgets(){

              console.log('Load widgets');

              let self = this;
              this.is_loading = true;

              this.default_widgets = this.widgets;

              // try to load widgets
              // add new widgets if loaded widgets are not found


              let savedPrimaryWidgets = JSON.parse(localStorage.getItem('widget_panel::' + self.panelType + '::primary'));
              let savedSecondaryWidgets = JSON.parse(localStorage.getItem('widget_panel::' + self.panelType + '::secondary'));


              for (let i = 0; i < self.widgets.length; i++) {


                if (savedPrimaryWidgets != null) {


                  let savedWidget = savedPrimaryWidgets.find(widget => widget.component == self.widgets[i].component);

                  if (savedWidget) {

                    self.widgets[i].location = "primary";
                    self.widgets[i].active = savedWidget.active;
                    self.widgets[i].position = savedWidget.position;

                  }

                }

                if (savedSecondaryWidgets != null) {

                  let savedWidget = savedSecondaryWidgets.find(widget => widget.component == self.widgets[i].component);

                  if (savedWidget) {

                    self.widgets[i].location = "secondary";
                    self.widgets[i].active = savedWidget.active;
                    self.widgets[i].position = savedWidget.position;

                  }

                }


                if (typeof self.widgets[i].roles == 'object') {


                  let show = (self.session.user_data.roles_inherited.filter(value => self.widgets[i].roles.includes(value))).length;

                  if (show == 0) {
                    self.widgets[i].active = false;
                  }

                }


                if (this.widgets[i].location == 'primary') {
                  this.primary_widgets.push(this.widgets[i])
                } else if (this.widgets[i].location == 'secondary') {
                  this.secondary_widgets.push(this.widgets[i])
                }

              }

              //sort widgets

              this.primary_widgets.sort(function (a, b) {
                return a.position - b.position;
              });
              this.secondary_widgets.sort(function (a, b) {
                return a.position - b.position;
              });


              this.is_loading = false;


              this.saveWidgets();


            },

        }


    }

</script>



<style lang="scss" scoped>

    .handle {
        cursor: pointer;
    }

</style>
